import {
  AddToListIcon,
  Layers01Icon,
  NewsIcon,
  ShoppingCart01Icon,
  UserMultipleIcon,
  User03Icon,
  GroupItemsIcon,
  Archive02Icon,
} from '@hugeicons/core-free-icons';
import { NavItem } from 'svnxii-ng-shared/components';

export const PROCUREMENT_NAV_ITEMS: NavItem[] = [
 
  {
    title: 'Purchase Requests',
    icon: AddToListIcon,
    route: '/app/procurement/purchase-requests',
  },
  { title: 'Vendors', icon: UserMultipleIcon, route: '/app/procurement/vendors' },
  { title: 'Quotations', icon: NewsIcon, route: '/app/procurement/purchase-quotations' },
  {
    title: 'Purchase Orders',
    icon: ShoppingCart01Icon,
    route: '/app/procurement/purchase-orders',
  },
  {
    title: 'Vendor Categories',
    icon: Layers01Icon,
    route: '/app/procurement/categories',
  },
  {
    title: 'Item Categories',
    icon: GroupItemsIcon,
    route: '/app/procurement/item-categories',
  },
  { title: 'Item Cards', icon: Archive02Icon, route: '/app/procurement/item-cards' },
  {
    title: 'Account',
    devFeature: true,
    icon: User03Icon,
    route: '/app/procurement/notifications',
  },
   {
    title: 'Replenish Requests',
    icon: Layers01Icon,
    route: '/app/procurement/replenish-requests',
  },
];
